import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';

/**
 *  APM: Alternative Payment Method
 *  */
const notAPM: PaymentMethod[] = [
  PaymentMethod.CreditCard,
  PaymentMethod.InPerson,
  PaymentMethod.Offline,
  PaymentMethod.FakePaymentMethod,
  PaymentMethod.Cash,
  PaymentMethod.POS,
  PaymentMethod.SquarePOS,
];

export const isAPM = (pMethodName: PaymentMethod): boolean =>
  !notAPM.includes(pMethodName);
